export default __webpack_public_path__ + "bcf37d666ce10b3556cd04b17d96d68d.woff2";